const DISPATCH_INITIAL_FILTERS = {
  customerName: null,
  customerDocumentNumber: null,
  dispatchNumber: null,
  quoteNumber: null,
  invoiceNumber: null,
  orderNumber: null,
  headerStatus: null,
  initDate: null,
  endDate: null,
  pageNumber: 1,
  pageSize: 10,
}

export function buildDispatchSearchPayload(filters) {
  const hasDateRange = filters.initDate || filters.endDate
  const hasHeaderStatus = filters.headerStatus?.length > 0
  const hasActiveFilters =
    filters.customerName ||
    filters.customerDocumentNumber ||
    filters.dispatchNumber ||
    filters.quoteNumber ||
    filters.invoiceNumber ||
    filters.orderNumber ||
    hasHeaderStatus ||
    hasDateRange
  const toDateOnly = dateStr => (dateStr ? dateStr.substring(0, 10) : undefined)
  const warehouseIds =
    hasActiveFilters || !filters.warehouseId ? undefined : [filters.warehouseId]

  return {
    pageNumber: filters.pageNumber,
    pageSize: filters.pageSize,
    companyId: filters.companyId,
    warehouseIds,
    customerName: filters.customerName || undefined,
    customerNumber: filters.customerDocumentNumber || undefined,
    dispatchNumber: filters.dispatchNumber || undefined,
    quoteNumber: filters.quoteNumber || undefined,
    invoiceNumber: filters.invoiceNumber || undefined,
    orderNumber: filters.orderNumber || undefined,
    headerStatusIds: hasHeaderStatus ? filters.headerStatus : undefined,
    dateStart: toDateOnly(filters.initDate),
    dateEnd: toDateOnly(filters.endDate),
    ignoreDateFilter: hasDateRange ? undefined : true,
  }
}

export const dispatchFilterFields = [
  {
    key: 'dispatchNumber',
    i18nKey: 'SEARCH_QUOTATION_T.NUMBER_DESPACHO_LABEL',
    testId: 'input-dispatchid-filter',
  },
  {
    key: 'quoteNumber',
    i18nKey: 'SEARCH_QUOTATION_T.NUMBER_QUOTATION_LABEL',
    testId: 'input-quoteid-filter',
  },
  {
    key: 'invoiceNumber',
    i18nKey: 'SEARCH_QUOTATION_T.INVOICE_NUMBER',
    testId: 'input-invoiceid-filter',
  },
  {
    key: 'orderNumber',
    i18nKey: 'SEARCH_QUOTATION_T.NUMBER_ORDER_LABEL',
    testId: 'input-orderid-filter',
  },
]

export const dispatchDocumentsSearchConfig = {
  initialFilters: DISPATCH_INITIAL_FILTERS,
  buildPayload: buildDispatchSearchPayload,
}
